import React from "react";
import { Modal, Button } from "antd";
import API_URL from "../../../../common/url";
import $ from '../../../../common/AjaxRequest';
import TableC from "../../../basicElement/TableC";
import ExportUtil from "../../../../common/ExportUtil";

class ProgressModal extends React.Component {
    state = {
        visible: false,
        record: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        type: '',
    }

    show = (record, type) => {
        this.setState({
            visible: true,
            record,
            type: type === 'accountsReceivableCl' ? 'REQUEST_FUNDS' : 'PAYMENT_COLLECTION',
        },() => {
            this.loadData();
        });
    }

    loadData = () => {
        const { pagination, record, type } = this.state;
        const { investigationId, investigationJdeContractId } = record;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryRemittanceProgressWithPage,
            data: {
                offset: current,
                limit: pageSize,
                investigationId,
                investigationJdeContractId,
                type,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination
                });
            }
        };
        $.sendRequest(options);
    };

    hide = () => {
        this.setState({ visible: false });
    }

    getColumns = () => {
        const { type } = this.state;
        const columns = [
            {
                title: '请款单号',
                dataIndex: 'remittanceCode',
                key: 'remittanceCode',
                width: 100,
            }, {
                title: 'JDE项目号',
                dataIndex: 'investigationJdeContractCode',
                key: 'investigationJdeContractCode',
                width: 100,
            }, {
                title: '合同主键',
                dataIndex: 'investigationJdeContractId',
                key: 'investigationJdeContractId',
                width: 100,
            }, {
                title: '合同额含税/人民币(元)',
                dataIndex: 'jdeContractAmount',
                key: 'jdeContractAmount',
                width: 160,
            }, {
                title: '客户付款单位',
                dataIndex: 'customerCompany',
                key: 'customerCompany',
                width: 100,
            }, {
                title: '客户CSA',
                dataIndex: 'csaNameCode',
                key: 'csaNameCode',
                width: 100,
            }, {
                title: '请款笔数',
                dataIndex: 'remittanceNum',
                key: 'remittanceNum',
                width: 100,
            }, {
                title: '请款节点',
                dataIndex: 'cashReqNode',
                key: 'cashReqNode',
                width: 100,
            }, {
                title: '合同约定请款金额/人民币(元)',
                dataIndex: 'remittanceAmount',
                key: 'remittanceAmount',
                width: 180,
            }
        ];
        if (type == 'REQUEST_FUNDS') {
            columns.push({
                title: 'milestone到达日期',
                dataIndex: 'cashReqNodeDate',
                key: 'cashReqNodeDate',
                width: 120,
            }, {
                title: '请款卡脖子节点',
                dataIndex: 'paymentStopBreathingCode',
                key: 'paymentStopBreathingCode',
                width: 120,
            }, {
                title: '请款卡脖子原因',
                dataIndex: 'paymentStopBreathingReason',
                key: 'paymentStopBreathingReason',
                width: 120,
            }, {
                title: '请款进度',
                dataIndex: 'paymentProgress',
                key: 'paymentProgress',
                width: 100,
            }, {
                title: '请款进度具体描述',
                dataIndex: 'paymentProgressComment',
                key: 'paymentProgressComment',
                width: 120,
            })
        } else {
            columns.push({
                title: '发票金额(含税总额)总金额',
                dataIndex: 'grossAmount',
                key: 'grossAmount',
                width: 120,
            }, {
                title: '回款卡脖子节点',
                dataIndex: 'receivingStopBreathingCode',
                key: 'receivingStopBreathingCode',
                width: 120,
            }, {
                title: '回款进度具体描述',
                dataIndex: 'receivingStopBreathingReason',
                key: 'receivingStopBreathingReason',
                width: 120,
            }, {
                title: '请款进度',
                dataIndex: 'paymentProgress',
                key: 'paymentProgress',
                width: 100,
            })
        }
        return columns;
    };

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { record: { investigationId, investigationJdeContractId }, type } = this.state;
        const url = API_URL.investigation.exportRemittanceProgress;
        ExportUtil.export({
            investigationId,
            investigationJdeContractId,
            type,
        }, null, url);
    }

    render() {
        const { visible, pagination, data, loading, type } = this.state;
        return (
            <Modal
                title={type == 'REQUEST_FUNDS' ? "请款详情" : "回款详情"}
                visible={visible}
                onCancel={this.hide}
                className="create-modal"
                width="1050px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div style={{ display: 'flex', flexDirection: 'column', padding: '0 10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
                        <Button key="export" type="primary" onClick={this.export}>导出</Button>
                    </div>
                    <div>
                        <TableC
                            data={data}
                            scrollY={500}
                            loading={loading}
                            columns={this.getColumns()}
                            rowKey="contractRemittanceApplicationId"
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ProgressModal;



// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/components/ProgressModal.js